import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Layout, Row, Col, Empty, Modal } from 'antd';
import TitleAndNew from '../Components/TitleAndNew/TitleAndNew';
import UserTabs from '../Components/UserTabs/UserTabs';
import DynamicTable from '../Components/DynamicTable/DynamicTable';
import { REQUEST_GET_USER_DATA_FOR_ADMIN } from '../Redux/constants/constants';
import TitleAndNew2 from '../Components/TitleAndNew2/TitleAndNew2';
import NewUser from '../Components/Forms/NewUser';

const { Content } = Layout;

const AdminUsers = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.currentUser);
  const [visible, setVisible] = useState(false);

  const showModal = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  // if user is already loaded, refresh its data
  // needed when some user or project properties changed that need to be reflected in user
  useEffect(() => {
    if (currentUser.name) {
      dispatch({
        type: REQUEST_GET_USER_DATA_FOR_ADMIN,
        payload: currentUser.id,
      });
    }
  }, []);

  return (
    <Layout>
      <Content style={{ margin: '36px', minHeight: '80vh' }}>
        <TitleAndNew2
          titleText={'Pracownicy'}
          buttonText={'Nowy pracownik'}
          action={showModal}
        />
        <Row gutter={16}>
          <Col span={7}>
            <div
              style={{
                background: '#fff',
                padding: '16px',
                borderRadius: '8px',
              }}
            >
              <DynamicTable type={'users'} />
            </div>
          </Col>
          <Col span={17}>
            <div
              style={{
                background: '#fff',
                padding: '16px',
                borderRadius: '8px',
              }}
            >
              {currentUser.id || currentUser.newUser ? (
                <UserTabs />
              ) : (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={<span>Wybierz pracownika</span>}
                />
              )}
            </div>
          </Col>
        </Row>
      </Content>
      <Modal
        title="Nowy pracownik"
        visible={visible}
        onCancel={handleCancel}
        footer={null}
        destroyOnClose={true}
      >
        <NewUser />
      </Modal>
    </Layout>
  );
};

export default AdminUsers;
